// extracted by mini-css-extract-plugin
export default {"materials":"BoxMaterials_materials__mlZQe","materialsTitle":"BoxMaterials_materialsTitle__Ta6mY"};